namespace $.$$ {

	export class $shm_hitalama_process_logs extends $.$shm_hitalama_process_logs {

		@ $mol_mem
		processes() {
			return [ ... this.$.$shm_hitalama_process.roots() ].reverse()
		}

		@ $mol_mem
		rows() {
			return this.processes().map( ( _, index )=> this.Row( index ) )
		}

		process( index: number ) {
			return this.processes()[ index ] ?? null
		}

		total() {
			return String( this.$.$shm_hitalama_process.all().length )
		}

		empty_visible() {
			return this.processes().length ? [] : super.empty_visible()
		}

	}

}
